// Local Development Configuration

// 🔧 IMPOSTA L'AMBIENTE QUI - Cambia questo valore per cambiare ambiente
const CURRENT_ENVIRONMENT = 'production'; // Valori possibili: 'development', 'labs', 'production'

// Debug: log dell'ambiente corrente
console.log('🌍 Environment set to:', CURRENT_ENVIRONMENT);

/** User ID usato con `npm start` (solo NODE_ENV=development) */
export const DEV_USER_ID = 3;

export const LOCAL_CONFIG = {
  // Cognito Configuration per tre ambienti: development, labs, production
  COGNITO: (() => {
    switch (CURRENT_ENVIRONMENT) {
      case 'development':
        return {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'your-cognito-domain.auth.eu-west-1.amazoncognito.com',
          client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || 'your-client-id',
          region: process.env.REACT_APP_COGNITO_REGION || 'eu-west-1'
        };
      case 'labs':
        return {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'eu-west-1qnfy3xnde.auth.eu-west-1.amazoncognito.com',
          client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || '74f5mgp979ueq4qepgm8ftsdli',
          region: process.env.REACT_APP_COGNITO_REGION || 'eu-west-1'
        };
      case 'production':
        return {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'eu-west-1akjphjw2s.auth.eu-west-1.amazoncognito.com',
          client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || '5iummgtnggp6aeamiolek1n10m',
          region: process.env.REACT_APP_COGNITO_REGION || 'eu-west-1'
        };
      default:
        // Default a labs se l'ambiente non è riconosciuto
        return {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'eu-west-1qnfy3xnde.auth.eu-west-1.amazoncognito.com',
          client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || '74f5mgp979ueq4qepgm8ftsdli',
          region: process.env.REACT_APP_COGNITO_REGION || 'eu-west-1'
        };
    }
  })(),
  
  // API Configuration for Local Development
  API: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001'
  },
  
  // Redirect URLs per tre ambienti: development, labs, production
  REDIRECT_URLS: {
    login: (() => {
      switch (CURRENT_ENVIRONMENT) {
        case 'development':
          return 'http://localhost:3000';
        case 'labs':
          return 'https://runtimesheet.labs.avvale.com';
        case 'production':
          return 'https://runtimesheet.avvale.com';
        default:
          return 'https://runtimesheet.labs.avvale.com'; // Default a labs
      }
    })(),
    logout: (() => {
      switch (CURRENT_ENVIRONMENT) {
        case 'development':
          return 'http://localhost:3000';
        case 'labs':
          return 'https://runtimesheet.labs.avvale.com';
        case 'production':
          return 'https://runtimesheet.avvale.com';
        default:
          return 'https://runtimesheet.labs.avvale.com'; // Default a labs
      }
    })()
  },
  
  // OIDC Configuration per tre ambienti: development, labs, production
  OIDC: (() => {
    switch (CURRENT_ENVIRONMENT) {
      case 'development':
        return {
          authority: process.env.REACT_APP_OIDC_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/your-pool-id",
          client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "your-client-id",
          redirect_uri: "http://localhost:3000",
          response_type: "code",
          scope: "email openid phone"
        };
      case 'labs':
        return {
          authority: process.env.REACT_APP_OIDC_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_qNFY3xNde",
          client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "3lletgh4vquih40po07ed906fg",
          redirect_uri: "https://runtimesheet.labs.avvale.com",
          response_type: "code",
          scope: "email openid phone"
        };
      case 'production':
        return {
          authority: process.env.REACT_APP_OIDC_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_aKJphjW2S",
          client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "5iummgtnggp6aeamiolek1n10m",
          redirect_uri: "https://runtimesheet.avvale.com",
          response_type: "code",
          scope: "email openid phone"
        };
      default:
        // Default a labs se l'ambiente non è riconosciuto
        return {
          authority: process.env.REACT_APP_OIDC_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_qNFY3xNde",
          client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "3lletgh4vquih40po07ed906fg",
          redirect_uri: "https://runtimesheet.labs.avvale.com",
          response_type: "code",
          scope: "email openid phone"
        };
    }
  })(),

  // Feature flags per ambiente (Contract / Report Mapping)
  FEATURES: (() => {
    switch (CURRENT_ENVIRONMENT) {
      case 'production':
        return {
          ENABLE_TAB_CONTRACT: false,
          ENABLE_TAB_MAPPING: true,
        };
      case 'labs':
        return {
          ENABLE_TAB_CONTRACT: true,
          ENABLE_TAB_MAPPING: true,
        };
      case 'development':
      default:
        return {
          ENABLE_TAB_CONTRACT: true,
          ENABLE_TAB_MAPPING: true,
        };
    }
  })(),

};

export const { ENABLE_TAB_CONTRACT, ENABLE_TAB_MAPPING } = LOCAL_CONFIG.FEATURES;

// Helper function to check if running locally
export const isLocalDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

// Helper function to check if running in labs environment
export const isLabsEnvironment = () => {
  return process.env.NODE_ENV === 'labs';
};

// Helper function to check if running in production environment
export const isProductionEnvironment = () => {
  return process.env.NODE_ENV === 'production';
};

// Helper function to get current environment
export const getCurrentEnvironment = () => {
  return CURRENT_ENVIRONMENT; // Ritorna l'ambiente configurato in questo file
};

// Helper function to get the appropriate redirect URI
export const getRedirectUri = () => {
  return LOCAL_CONFIG.REDIRECT_URLS.login;
};

  // Helper function to get the appropriate logout URI
export const getLogoutUri = () => {
  return LOCAL_CONFIG.REDIRECT_URLS.logout;
};

// Support Configuration
export const SUPPORT_CONFIG = {
  email: 'runtimeapp-support@avvale-services.atlassian.net'
};

// Working Days Configuration
export const WORKING_DAYS_CONFIG = {
  // Numero di giorni lavorativi dopo l'inizio del mese per permettere l'editing del mese precedente
  // Valori possibili: 1, 2, 3, 4, 5, 10, etc.
  // 1 = solo il primo giorno lavorativo del mese
  // 5 = primi 5 giorni lavorativi del mese
  // 10 = primi 10 giorni lavorativi del mese
  previousMonthEditingDays: 31,
  
  // Giorni della settimana considerati lavorativi (0 = domenica, 1 = lunedì, ..., 6 = sabato)
  // Esempi:
  // [1, 2, 3, 4, 5] = Lunedì-Venerdì (standard)
  // [1, 2, 3, 4, 5, 6] = Lunedì-Sabato (incluso sabato)
  // [1, 2, 3, 4, 5, 6, 0] = Tutti i giorni della settimana
  // [1, 3, 5] = Solo Lunedì, Mercoledì, Venerdì
  workingDaysOfWeek: [1, 2, 3, 4, 5], // Lunedì-Venerdì
  
  // Nome dei giorni per debug/logging
  dayNames: {
    0: 'Sunday',
    1: 'Monday', 
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
  }
};

export const FORECAST_CONFIG = {
  activityName: 'FORECAST',
  forecastCellColor: '#1976d2',
  forecastCellBg: '#e3f2fd',
  editableHighlightBg: '#fff3e0',
  maxHoursPerDay: 8,
};